import React, { useState } from "react";
import { Button, Form, Input, Modal, Radio } from "antd";
import PropTypes from "prop-types";
import { EditOutlined } from "@ant-design/icons/lib";

export const ManagedResourceTypeEditModal = ({
  title,
  icon,
  buttonText,
  onFinish,
  onFinishFailed,
  initialValues,
}) => {
  const [editModal, setEditModal] = useState(false);
  const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
  };
  const [form] = Form.useForm();

  const handleCancel = () => {
    setEditModal(false);
  };
  const handleOk = () => {
    form.submit();
    setEditModal(false);
  };
  const showModal = () => {
    setEditModal(true);
  };

  return (
    <>
      <Button icon={icon ? icon : <EditOutlined />} onClick={showModal}>
        {buttonText}
      </Button>
      <Modal
        title={title}
        open={editModal}
        onCancel={handleCancel}
        onOk={handleOk}
        okText="Save"
        width={700}
      >
        <Form
          {...layout}
          form={form}
          initialValues={initialValues}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          style={{ maxWidth: 700, marginTop: "10px" }}
        >
          <Form.Item hidden name="id">
            <Input type="hidden" />
          </Form.Item>

          <Form.Item
            label="Managed Resource Type Name"
            name="resourceTypeName"
            tooltip="Select carefully as it cannot be modified afterwards"
          >
            <Input
              placeholder="Managed Resource Type Name"
              disabled={initialValues?.resourceTypeName ? true : false}
            />
          </Form.Item>

          <Form.Item label="Block Grace Period Days" name="blockGracePeriod">
            <Input placeholder="Number of days" />
          </Form.Item>
          <Form.Item
            label="Archive Grace Period Days"
            name="archiveGracePeriod"
          >
            <Input placeholder="Number of days" />
          </Form.Item>
          <Form.Item label="Delete Grace Period Days" name="deleteGracePeriod">
            <Input placeholder="Number of days" />
          </Form.Item>
          <Form.Item
            label="Application Subscription Settings Id"
            name="applicationSubscriptionId"
            hidden
          >
            <Input disabled />
          </Form.Item>
          <Form.Item label="Initial State" name="initialState">
            <Radio.Group>
              <Radio.Button value="Active">Active</Radio.Button>
              <Radio.Button value="Created">Created</Radio.Button>
            </Radio.Group>
          </Form.Item>

          <Form.Item
            label="Manage Resource URL template"
            name="managementUrlTemplate"
            tooltip="Url where users are directed when clicking the button manage resource. Format should be like URL/{resourceIdentifier}"
          >
            <Input placeholder="Manage Resource URL" />
          </Form.Item>
          <Form.Item
            label="Create Resource URL"
            name="createResourceUrl"
            tooltip="URL where users are directed when clicking the button create new resource."
          >
            <Input placeholder="Create Resource URL" />
          </Form.Item>
          <Form.Item
            label="Access Resource URL"
            name="accessUrlTemplate"
            tooltip="URL where users are directed when clicking the resource name."
          >
            <Input placeholder="Access Resource URL" />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

ManagedResourceTypeEditModal.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.element,
  buttonText: PropTypes.string,
  // form: PropTypes.object.isRequired,
  onFinish: PropTypes.func.isRequired,
  onFinishFailed: PropTypes.func.isRequired,
  initialValues: PropTypes.object,
};
